import { Button, Paper, styled, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import { Map } from "leaflet";

import { MeasureConf } from "types/types";

import { NavLink } from "components/navigation/NavLink";
import { MeasureItem } from "./MeasureItem";

interface Props {
  measureConfigs: MeasureConf[];
  mapRef: Map;
  isReadOnly: boolean;
  label: string;
  noResultsFound: string;
  buttonTitle: string;
  navSuffix: string;
  uuid: string;
}

export function MeasuresOverview(props: Props) {
  const {
    measureConfigs,
    label,
    buttonTitle,
    isReadOnly,
    noResultsFound,
    mapRef,
    navSuffix,
    uuid,
  } = props;
  return (
    <StyledPaddedPaper elevation={0}>
      <Typography variant="h3-black" component="h2">
        {label}
      </Typography>

      <Paper className="measures-section" elevation={0}>
        {measureConfigs.length === 0 && (
          <Typography>{noResultsFound}</Typography>
        )}

        {measureConfigs.length > 0 &&
          measureConfigs.map((measureConfig) => (
            <MeasureItem
              key={measureConfig.id}
              measureConfig={measureConfig}
              isReadOnly={isReadOnly}
              measureConfigs={measureConfigs}
              mapRef={mapRef}
              uuid={uuid}
            />
          ))}
      </Paper>
      <Button
        startIcon={<Add />}
        component={NavLink}
        disabled={isReadOnly}
        variant="reverse-contained"
        to={`/${uuid}/measure/${navSuffix}/select`}
      >
        {buttonTitle}
      </Button>
    </StyledPaddedPaper>
  );
}

const StyledPaddedPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: flex-start;
  overflow: auto;
  min-height: ${({ theme }) => theme.spacing(18)};
  margin-right: -${({ theme }) => theme.spacing(2)};
  .measures-section {
    display: flex;
    flex-direction: column;
    overflow: auto;
    width: 100%;
    gap: ${({ theme }) => theme.spacing(2)};
    padding-right: ${({ theme }) => theme.spacing(2)};
  }
`;
